export default __webpack_public_path__ + "static/media/fishTtsIt_It60.105dd584.mp3";